import { CONSUMER_ID_MISSING, ID_FORMAT_UNSUPPORTED } from '../constants/api-error-enums';
import ConsumerIdentity from '../schemas/consumer-identity';
import constructValidationMessage from './construct-validation-message';
import isEmail from './is-email';

const validateIdLookupData = data => {
  const { error } = ConsumerIdentity.validate(data, { abortEarly: false });
  //VCO-14936 - invalid email check, sdk throw error earlier before making back end call
  const isValidEmail = isEmail(data?.identityValue);
  // id unsupported format if given wrong data type or fails email check
  const ID_FORMAT_UNSUPPORTED_ERROR =
    error &&
    error.details.some(
      o => o.context.key === 'identityValue' && (o.type === 'string.email' || 'string.base')
    );
  // consumer missing if some issue with type, or passed empty str as identityValue
  const CONSUMER_ID_MISSING_ERROR =
    (error &&
      error.details.some(o => o.context.key === 'identityValue' && o.type === 'string.empty')) ||
    (error && error.details.some(o => o.context.key === 'type'));
  let reason;
  if (CONSUMER_ID_MISSING_ERROR) {
    reason = CONSUMER_ID_MISSING;
  } else if (ID_FORMAT_UNSUPPORTED_ERROR || !isValidEmail) {
    reason = ID_FORMAT_UNSUPPORTED;
  }
  return constructValidationMessage(error, 'identityLookup()', reason);
};

export default validateIdLookupData;
